<h2 mat-dialog-title>Połącz z wydarzeniem</h2>

<mat-dialog-content>
	<app-generic-mat-autocomplete
		[placeholder]="'Nazwa wydarzenia (tylko kategoria OSKAR, GRUPA i OSKAR SAMOLOT)'"
		[apiUrl]="environment.erpUrl + '/tourismEvents/'"
		[apiSearchParam]="apiSearchParam()"
		[responseMapper]="erpEventsMapper"
		[displayKeys]="['displayName']"
		[showOptionsOnFocus]="true"
		(selected)="onTourismEventSelected($event)"
	>
	</app-generic-mat-autocomplete>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button mat-dialog-close>Anuluj</button>
	<button mat-raised-button color="primary" [disabled]="!chosenEvent()" (click)="assignTourismEvent()">Połącz</button>
</mat-dialog-actions>
